// ── EmployeeView 스타일 상수 ──────────────────────────────────────────────────
// 직원 위장 접속 페이지 전용 CSS-in-JS 스타일 모음

// ── 레이아웃 ────────────────────────────────────────────────────────────────
/** 페이지 최대 너비 컨테이너 */
export const containerStyle = {
  maxWidth: 560,
  margin: '40px auto',
  padding: '0 16px',
};

/** 카드 외곽 스타일 */
export const cardStyle = {
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  borderRadius: 12,
  padding: '28px 28px 32px',
};

// ── 텍스트 ─────────────────────────────────────────────────────────────────
/** 카드 타이틀 */
export const titleStyle = {
  fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 6,
};

/** 카드 설명 텍스트 */
export const descStyle = {
  fontSize: 13, color: 'var(--text-muted)', marginBottom: 24, lineHeight: 1.6,
};

/** 인풋 레이블 */
export const labelStyle = {
  display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-sub)', marginBottom: 6,
};

// ── 검색 입력 ───────────────────────────────────────────────────────────────
/** 인풋 래퍼 (상대 위치 — 드롭다운 기준점) */
export const inputWrapStyle = {
  position: 'relative',
};

/** 텍스트 인풋 */
export const inputStyle = {
  width: '100%', boxSizing: 'border-box',
  border: '1px solid var(--border)', borderRadius: 8,
  padding: '9px 12px', fontSize: 14,
  background: 'var(--bg-card)', color: 'var(--text)', outline: 'none',
};

// ── 자동완성 드롭다운 ────────────────────────────────────────────────────────
/** 드롭다운 목록 컨테이너 */
export const dropdownStyle = {
  position: 'absolute', top: '100%', left: 0, right: 0,
  background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 8,
  boxShadow: '0 4px 12px rgba(0,0,0,.1)',
  zIndex: 100, maxHeight: 240, overflowY: 'auto', marginTop: 4,
};

/** 드롭다운 기본 항목 */
export const dropdownItemStyle = {
  padding: '9px 14px', cursor: 'pointer', fontSize: 14,
  color: 'var(--text)', borderBottom: '1px solid var(--bg-subtle)',
};

/** 드롭다운 hover 항목 */
export const dropdownItemHoverStyle = {
  ...dropdownItemStyle,
  background: 'rgba(37,99,235,0.08)',
};

// ── 선택된 직원 카드 ─────────────────────────────────────────────────────────
/** 선택 확인 카드 */
export const selectedCardStyle = {
  display: 'flex', alignItems: 'center', gap: 12,
  background: 'var(--bg-subtle)', border: '1px solid var(--border)',
  borderRadius: 8, padding: '12px 14px', marginTop: 12,
};

/** 선택된 직원 정보 텍스트 영역 */
export const selectedInfoStyle = {
  flex: 1, fontSize: 14, color: 'var(--text-sub)',
};

// ── 버튼 ────────────────────────────────────────────────────────────────────
/** 주 액션 버튼 (활성) */
export const btnPrimaryStyle = {
  display: 'block', width: '100%', padding: '11px 0', marginTop: 20,
  background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8,
  fontSize: 15, fontWeight: 600, cursor: 'pointer', letterSpacing: '-0.01em',
};

/** 주 액션 버튼 (비활성) */
export const btnDisabledStyle = {
  ...btnPrimaryStyle,
  background: 'var(--text-muted)',
  cursor: 'not-allowed',
};

// ── 메시지 박스 ──────────────────────────────────────────────────────────────
/** 오류 메시지 박스 */
export const errorStyle = {
  marginTop: 12, padding: '10px 12px',
  background: '#fef2f2', border: '1px solid #fca5a5',
  borderRadius: 8, fontSize: 13, color: '#b91c1c',
};

/** 주의사항 안내 박스 */
export const noteStyle = {
  marginTop: 20, padding: '10px 14px',
  background: '#fffbeb', border: '1px solid #fde68a',
  borderRadius: 8, fontSize: 12, color: '#92400e', lineHeight: 1.6,
};
